module.exports = __webpack_public_path__ + "img/icon_map_81_off.2958cb7b.png";